import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';

export default function modificationLigne(devisCommande, ordre, nouvelleLigne) {
  const index = devisCommande.lignesCommande.findIndex(
    ligneCommande => ligneCommande.ordre === ordre,
  );
  devisCommande.lignesCommande.splice(index, 1);
  devisCommande.lignesCommande.splice(index, 0, nouvelleLigne);
  deleteLignesEcheanciersInutiles(devisCommande);
}
